import { useEffect, useState } from 'react';
import InputField from '../../../components/Forms/Input/InputField';
import SimpleSearchSelect from '../../../components/Forms/Input/SimpleSearchSelect';
import { useImportPurchase } from '../../../hooks/purchases/useImportPurchase';
import { useProduct } from '../../../hooks/useProduct';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';

const AddImportProductForm = () => {
  const { handlerAddProduct } = useImportPurchase();
  const { productsDropdown, handlerGetProductsForDropdownByItemType } =
    useProduct();

  const { form } = useSelector((state: RootState) => state.basePurchase);

  const [productForm, setProductForm] = useState({
    productId: '',
    productName: '',
    quantity: '',
    amount: '',
    unit: '',
  });

  const [errors, setErrors] = useState<Record<string, string>>({});

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setProductForm((prev) => ({ ...prev, [name]: value }));
  };

  const resetForm = () => {
    setProductForm({
      productId: '',
      productName: '',
      quantity: '',
      amount: '',
      unit: '',
    });
    setErrors({});
  };

  const handleSave = async () => {
    const newErrors: typeof errors = {};
    if (!productForm.productId) newErrors.productId = 'Producto requerido';
    if (!productForm.quantity) newErrors.quantity = 'Cantidad requerida';
    if (!productForm.amount) newErrors.amount = 'Monto requerido';

    if (!form.id) {
      newErrors.productId = 'Primero debes guardar el encabezado de la compra';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      handlerAddProduct({
        purchaseId: form.id,
        productId: Number(productForm.productId),
        productName: productForm.productName,
        quantity: Number(productForm.quantity),
        amount: Number(productForm.amount),
      });

      resetForm();
    } catch (error) {
      console.error('❌ Error al guardar producto de importación:', error);
    }
  };

  useEffect(() => {
    handlerGetProductsForDropdownByItemType(1);
  }, []);

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
      <SimpleSearchSelect
        label="Producto"
        name="productId"
        iconKey="category"
        options={productsDropdown}
        selectedValue={
          productForm.productId ? Number(productForm.productId) : null
        }
        onSelect={(option: any) => {
          setProductForm((prev) => ({
            ...prev,
            productId: option.id,
            productName: option.name,
            unit: option.unit || '',
          }));
        }}
        error={errors.productId}
        required
      />

      <InputField
        label="Unidad de Medida"
        name="unit"
        iconKey="unitMeasure"
        value={productForm.unit}
        disabled
        type="text"
      />

      <InputField
        label="Cantidad"
        name="quantity"
        iconKey="product"
        type="number"
        value={productForm.quantity}
        onChange={handleChange}
        error={errors.quantity}
        required
      />

      <InputField
        label="Monto"
        name="amount" // ← aquí el nuevo name
        iconKey="dollar"
        type="number"
        value={productForm.amount}
        onChange={handleChange}
        error={errors.amount}
        required
      />

      {/* Fila 3 - Botones a lo largo de toda la fila */}
      <div className="col-span-1 mt-6 flex flex-col items-center justify-end gap-3 sm:col-span-2 sm:flex-row">
        <button
          type="button"
          onClick={handleSave}
          className="w-full rounded bg-primary px-4 py-2 text-white hover:bg-opacity-90 sm:w-auto"
        >
          Guardar
        </button>
        <button
          type="button"
          onClick={resetForm}
          className="w-full rounded bg-slate-500 px-4 py-2 text-white hover:bg-opacity-90 sm:w-auto"
        >
          Cancelar
        </button>
      </div>
    </div>
  );
};

export default AddImportProductForm;
